// extracted by mini-css-extract-plugin
export default {"saved_at":"saved_at__BmCe1","checkbox":"checkbox__SaKBw"};